<div *ngIf="loading$ | async" style="
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.4);
    width: 100%;
    height: 100vh;
    z-index: 1000;
    left: 0">
  <div class="d-flex align-items-center justify-content-center" [ngStyle]="{height: height, width: height}">
    <div id="main_spinner">
      <div id="rotate"></div>
    </div>
  </div>
</div>
